import axios from '@axios'
import baseConfig from '@/config/index'
const EBARIMT_SERVICE_PATH = baseConfig.EBARIMT_SERVICE_PATH
const TICKET_API_SERVICE_PATH = baseConfig.TICKET_API_SERVICE_PATH
const TEST_SERVICE_PATH = baseConfig.TEST_SERVICE_PATH

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchEbarimtData(ctx, payload) {
      const params = {
        page: payload.page,
        size: payload.per_page,
      }
      if (payload.phone_number) params.phone_number = payload.phone_number
      if (payload.date_from) params.date_from = payload.date_from
      if (payload.date_to) params.date_to = payload.date_to

      return new Promise((resolve, reject) => {
        axios
          .get(EBARIMT_SERVICE_PATH + '/v3/receipt/', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    returnReceipt(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(EBARIMT_SERVICE_PATH + '/v3/receipt/return', { receipt_id: payload.receipt_id })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sendNoatusData(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(EBARIMT_SERVICE_PATH + '/v3/posapi/send_data', { params: { send_date: payload.send_date } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    registerOrganization(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(TICKET_API_SERVICE_PATH + '/ebarimt/register_organization', {
            phone_number: payload.phone_number,
            register: payload.register,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getCustomerSummary(ctx, payload) {
      const params = {}
      if (payload.phone) params.phone_number = payload.phone
      if (payload.transaction_date) params.transaction_date = payload.transaction_date
      return new Promise((resolve, reject) => {
        axios
          .get(EBARIMT_SERVICE_PATH + '/v3/receipt/transactions/customer-summary', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sendReceiptEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(EBARIMT_SERVICE_PATH + '/v3/receipt/send-email', {
            receipt_id: payload.receipt_id,
            to_email: payload.to_email,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    generateReceipt(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(EBARIMT_SERVICE_PATH + '/v3/receipt/generate', {
            customer_id: payload.customer_id,
            transaction_date: payload.transaction_date,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
